<template>
  <!-- <v-container fill-height> -->
    <v-row class="justify-center align-center">
      <!-- min-height:200px;max-height:300px; -->
      <v-card color="#0A7EA5" style="min-height:200px;width:100%;" fill-height>
        <v-row class="mt-5 ml-5">
          <v-col cols="12">
        <v-btn text dark type="submit" color="#ffffff" width="100" @click="$router.push(`/login`)">
          <v-icon
        left
        dark
      >
      mdi-chevron-left
      </v-icon>
                Back
              </v-btn>
            </v-col>
            </v-row>
            <v-row class="justify-center align-center text-center ma-2">
              <v-col cols="12">
              <h1 class="white--text">Forgot Password</h1>
              </v-col>
            </v-row>
            <v-row class="justify-center align-center text-center ma-2">
              <v-col col="12">
              <h3 class="white--text">Email your email to receive a reset password link</h3>
              </v-col>
            </v-row>
           
      </v-card>
      <v-card style="width:400px;" class="mt-8 ma-2" elevation="0">
        <!-- <v-img
          class="white--text align-end"
          src="@/assets/login_bg.jpg"
          height="200px"
        > -->
        <v-form @submit.prevent="submit">
          <v-card-title primary-title style="color:#254e58" class="mb-n2">
          <h5>Please enter your Company Code</h5> 
          </v-card-title>
          <v-card-text>

            <!-- Username -->
            <v-text-field
              class="heightsize40"
              name="email"
              label="Company Code"
              id="com_code"
              v-model="account.com_code"
              outlined
              dense
            />

            </v-card-text>
          <v-card-title primary-title style="color:#254e58" class="mb-n2">
          <h5>Please enter your email</h5> 
          </v-card-title>
          <!-- </v-img> -->
          <v-card-text>

              <!-- Username -->
              <v-text-field
                class="heightsize40"
                name="email"
                label="Email"
                id="email"
                v-model="account.email"
                outlined
                dense
              />

              <v-row class="px-3 pt-8 pb-5 justify-center align-center text-center">
                <v-btn width="150" rounded dark type="submit" color="#0A7EA5">
                  Send
                </v-btn>
              </v-row>
        
          </v-card-text>
        </v-form>
      </v-card>

      <SuccessDialog
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
      />
    </v-row>
  <!-- </v-container> -->
</template>

<script>
import api from "@/services/api";
import { server } from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";

export default {
  mounted() {
    if (api.isLoggedIn()) {
      this.$router.push("/dashboard");
    }

    this.$hideLoader();
  },
  components: { SuccessDialog },
  data() {
    return {
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogAdd: false,
      isShowPassword: false,
      account: {
        email: "",
        com_code: ""
      },
    };
  },
  methods: {
    async submit() {
      if (this.account.com_code == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Input Company Code",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.account.email == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Input Email",
          "text-h5 red--text text-center"
        );
        return;
      }

      const res_reset = await api.getUserByEmailComCode(this.account.email,this.account.com_code);
      console.log(res_reset);
      // alert(res_edit.status);
      // console.log("res_reset", JSON.stringify(res_reset.data));
      // alert(res_reset.data.length);
      // if (res_reset.data.length > 0) {
      //   alert("Please check your email");
      // } else {
      //   alert("No data");
      // }
      if (res_reset.data.length > 0) {
        // this.$store.state.global_push_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Success",
        //   "Update data success",
        //   "text-h5 green--text text-center"
        // );
        //Send Mail
        this.$showLoader();
        var payload = {
          com_code: this.account.com_code,
          email: this.account.email,
          id: res_reset.data[0].id,
          subject: "Reset Password",
          message: "Please click link below to reset password",
          link: location.protocol + "//" + location.host,
        };
        const res_sendmail = await api.sendMailResetPassword(payload);
        this.$hideLoader();
        // console.log("res_sendmail", JSON.stringify(res_sendmail.data));
        // console.log("res_sendmail", res_sendmail.data.link);
        if (res_sendmail.data.link == true) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Success",
            res_sendmail.data.message,
            "text-h5 green--text text-center"
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            res_sendmail.data.message,
            "text-h5 red--text text-center"
          );
        }
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Email not found",
          "text-h5 red--text text-center"
        );
      }
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
};
</script>

<style>
.heightsize60 {
  height: 60px;
}

.heightsize40 {
  height: 40px;
}
</style>
